import { UserRound } from 'lucide-react'
import { useContext, useState } from 'react'

import BrokerContext from 'components/context/BrokerContext'
import { useGetBrokers } from 'components/hooks/needs_attention/useGetBrokers'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../../reusable/table/ComboboxMultiSelectFilter'
import FilterManagementDropdown from '../../needs_attention/FilterManagementDropdown'
import { filterByLabelAndExactValueCallback } from '../../needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../../types'

const CreatedByBrokerFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const { data, isLoading } = useGetBrokers()
  const brokers = data?.data
  const { currentBroker } = useContext(BrokerContext)

  // Add System option
  const systemOption: ComboboxFilterOption<string> = {
    label: 'System',
    value: 'system',
  }

  const pinnedBrokerOptions: ComboboxFilterOption<string>[] = [
    systemOption,
    ...(currentBroker ? [{ label: currentBroker?.broker_name, value: currentBroker?.id }] : [])
  ]

  const brokerOptions: ComboboxFilterOption<string>[] =
    brokers
      ?.map((broker) => ({
        label: broker.broker_name,
        value: broker.id,
      }))
      .filter((option) => option.value !== currentBroker?.id) || []

  const filteredPinnedBrokerOptions = pinnedBrokerOptions.filter(
    filterByLabelAndExactValueCallback(query)
  )
  const filteredBrokerOptions = brokerOptions.filter(
    filterByLabelAndExactValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[
          { groupLabel: 'Pinned', options: filteredPinnedBrokerOptions },
          { groupLabel: 'Brokers', options: filteredBrokerOptions },
        ]}
        placeholder='Search brokers to filter...'
        onValueChange={setQuery}
        isLoading={isLoading}
      >
        <FilterManagementDropdown
          {...props}
          options={[...pinnedBrokerOptions, ...brokerOptions]}
          noSelectionText='Created By'
          pluralIdentifier='brokers'
        >
          <UserRound size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default CreatedByBrokerFilter
